import type {
  AbsoluteQuantityAdjustmentResponseDTO,
  AllAdjustmentsResponseDTO,
  MeasureIntegrationDetailsDTO,
} from '@/src/api/types/procurement'
import type { RenewableSourceProfile } from '../LoadPlanningAdjustment.types'

export type AdjustmentRow = {
  id: string
  name: string
  type: keyof AllAdjustmentsResponseDTO | 'measure'
  scope?: 'LOCATION' | 'COMPANY'
  locationId?: number
  timeframeStart: string
  timeframeEnd: string
  createdAt: string
  warnings?: AdjustmentWarning[]
  unit?: string
  consumptionDelta?: number
  measureIntegrationDetails?: MeasureIntegrationDetailsDTO
  comment?: string
  baseLoad?: number
  adjustmentValue?: number
  adjustmentValueUnit?: string
  applicableWeekdays?: AbsoluteQuantityAdjustmentResponseDTO['applicableWeekdays']
  timeFrom?: string
  timeTo?: string
  percentageAdjustmentValue?: number
  referencePeriodStart?: string
  referencePeriodEnd?: string
  totalAnnualProduction?: number
  sourceProfile?: RenewableSourceProfile
  adjustmentType: keyof AllAdjustmentsResponseDTO
}

export enum AdjustmentWarning {
  HOLIDAY_OVERLAP = 'HOLIDAY_OVERLAP',
  MEASURE_ADJUSTMENT_OUTDATED = 'MEASURE_ADJUSTMENT_OUTDATED',
  REFERENCE_PERIOD_IGNORED = 'REFERENCE_PERIOD_IGNORED',
}
